module.exports = __webpack_public_path__ + "static/media/download.b6ffe017.svg";